module.exports = __webpack_public_path__ + "static/media/sentiment_sad.6297d3f3.svg";